// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__eqZdm","select":"Header_select__2c9St","clinic":"Header_clinic__1rc9_"};